import { type DrawerContentProps } from '../../../state';
import { DrawerLayout } from '../../layouts';

type Props = DrawerContentProps;

const DemoDrawer = ({ closeDrawer }: Props) => (
  <DrawerLayout closeDrawer={closeDrawer} title="Demo Drawer">
    Demo
  </DrawerLayout>
);

export default DemoDrawer;
